/*
  Copyright (c) 2018-present, Accuracy.
  All rights reserved.
*/
import {createStyles, StyleRules, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React, {memo} from 'react';

//----------------------------------------------------------------------------------------------------------------------
//- Styles
//----------------------------------------------------------------------------------------------------------------------
export type ContentClassKey = 'root';

const useStyles = makeStyles<Theme, {}, ContentClassKey>(
  (): StyleRules<ContentClassKey> =>
    createStyles({
      root: {
        backgroundColor: 'var(--color-bg)',
        color: 'var(--color-text)',
        flex: 1
      }
    }),
  {
    name: 'Content'
  });

//----------------------------------------------------------------------------------------------------------------------
//- Component
//----------------------------------------------------------------------------------------------------------------------
export type ContentProps = {
  className?: string;
  children?: React.ReactNode;
};

export default memo(({className, children}: ContentProps) => {
  // hooks
  const classes = useStyles({});

  return (
    <div className={classNames(classes.root, className)}>
      {children}
    </div>
  );
});
